// Departments.js
import React, { useState } from "react";
import "./Departments.css"; // ✅ create CSS for styling

function Departments({ departments, setDepartments, setDepartmentAdded }) {
  const [departmentName, setDepartmentName] = useState("");
  const [editingIndex, setEditingIndex] = useState(null);
  const [editedName, setEditedName] = useState("");

  const addDepartment = () => {
    if (departmentName.trim() === "") return;
    const newDept = { name: departmentName, courses: [] };
    setDepartments([...departments, newDept]);
    setDepartmentAdded(true);
    setDepartmentName("");
  };

  const deleteDepartment = (index) => {
    const updated = departments.filter((_, i) => i !== index);
    setDepartments(updated);
  };

  const startEditing = (index) => {
    setEditingIndex(index);
    setEditedName(departments[index].name);
  };

  const saveEdit = (index) => {
    const updated = [...departments];
    updated[index].name = editedName;
    setDepartments(updated);
    setEditingIndex(null);
    setEditedName("");
  };

  return (
    <div className="departments-section">
      <h2>Departments</h2>

      {/* Add new department */}
      <div style={{ marginBottom: "20px" }}>
        <input
          type="text"
          value={departmentName}
          onChange={(e) => setDepartmentName(e.target.value)}
          placeholder="Enter department name"
        />
        <button onClick={addDepartment}>Add Department</button>
      </div>

      {/* Table view like Courses */}
      <h3>Departments List</h3>
      <table className="departments-table">
        <thead>
          <tr>
            <th>Department Name</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {departments.map((dept, index) => (
            <tr key={index}>
              <td>
                {editingIndex === index ? (
                  <input
                    type="text"
                    value={editedName}
                    onChange={(e) => setEditedName(e.target.value)}
                  />
                ) : (
                  dept.name
                )}
              </td>
              <td>
                {editingIndex === index ? (
                  <>
                    <button className="btn-save" onClick={() => saveEdit(index)}>💾 Save</button>
                    <button className="btn-cancel" onClick={() => setEditingIndex(null)}>✖ Cancel</button>
                  </>
                ) : (
                  <>
                    <button className="btn-edit" onClick={() => startEditing(index)}>✏ Edit</button>
                    <button className="btn-delete" onClick={() => deleteDepartment(index)}>❌ Delete</button>
                  </>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default Departments;
